module.exports = __webpack_public_path__ + "img/icon_order_nodata.0495a6bc.png";